const focusRing = {
  outline: "3px solid rgba(14, 64, 137, 0.24)",
  outlineOffset: 2,
};

export const componentOverrides = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        minHeight: "100%",
        backgroundColor: "#f4f6f8",
      },
      body: {
        minHeight: "100%",
        margin: 0,
        backgroundColor: "#f4f6f8",
        color: "#172033",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
      },
      "#root": {
        minHeight: "100vh",
      },
      "*:focus-visible": focusRing,
      "::selection": {
        backgroundColor: "rgba(14, 64, 137, 0.16)",
      },
    },
  },
  MuiAppBar: {
    defaultProps: {
      color: "primary",
      elevation: 0,
    },
    styleOverrides: {
      root: {
        backgroundImage: "none",
        borderBottom: "1px solid rgba(255, 255, 255, 0.14)",
      },
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        minHeight: 38,
        borderRadius: 8,
        paddingInline: 16,
        fontWeight: 600,
        textTransform: "none",
        "&.Mui-focusVisible": focusRing,
      },
      containedError: {
        color: "#ffffff",
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        "&.Mui-focusVisible": focusRing,
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        backgroundColor: "#ffffff",
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#8d9aaf",
        },
        "&.Mui-focused": {
          boxShadow: "0 0 0 3px rgba(14, 64, 137, 0.12)",
        },
      },
      notchedOutline: {
        borderColor: "#cfd6e1",
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontWeight: 500,
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginLeft: 0,
        marginTop: 6,
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
      outlined: {
        borderColor: "#dde3ec",
      },
    },
  },
  MuiCard: {
    defaultProps: {
      variant: "outlined",
    },
    styleOverrides: {
      root: {
        borderRadius: 10,
        borderColor: "#dde3ec",
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: 20,
      },
      title: {
        fontSize: "1rem",
        fontWeight: 700,
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 20,
        "&:last-child": {
          paddingBottom: 20,
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 12,
        border: "1px solid #dde3ec",
        boxShadow: "0 24px 64px rgba(15, 23, 42, 0.2)",
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontSize: "1.125rem",
        fontWeight: 700,
      },
    },
  },
  MuiChip: {
    defaultProps: {
      size: "small",
    },
    styleOverrides: {
      root: {
        borderRadius: 999,
        fontWeight: 600,
      },
    },
  },
  MuiTooltip: {
    defaultProps: {
      arrow: true,
      enterDelay: 450,
    },
    styleOverrides: {
      tooltip: {
        borderRadius: 6,
        backgroundColor: "#172033",
        fontSize: "0.75rem",
        padding: "7px 10px",
      },
      arrow: {
        color: "#172033",
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        overflowX: "auto",
        border: "1px solid #dde3ec",
        borderRadius: 10,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderBottomColor: "#e7ebf1",
        padding: "13px 16px",
      },
      head: {
        backgroundColor: "#f7f8fa",
        color: "#42516a",
        fontSize: "0.75rem",
        fontWeight: 700,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        "&.MuiTableRow-hover:hover": {
          backgroundColor: "#f7f9fc",
        },
      },
    },
  },
  MuiTablePagination: {
    styleOverrides: {
      root: {
        borderTop: "1px solid #e7ebf1",
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        "&.Mui-focusVisible": focusRing,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        minHeight: 40,
        borderRadius: 6,
        marginInline: 6,
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: 8,
      },
    },
  },
};
